export enum ProductStore {
    None = '',
    Rental = 'Rental',
    Sales = 'Sales',
}
